module.exports = __webpack_public_path__ + "static/media/campus-platform-moduleC-bg.fe1cf18d.png";